import { hydrateRoot } from "react-dom/client";
import App from "../app";

const { appConfig, assetsUrl, contentStrings } = window.asos.pdlp.state;
delete window.asos.pdlp.state;

hydrateRoot(
  document.getElementById("react-root"),
  <App
    contentStrings={contentStrings}
    assetsUrl={assetsUrl}
    appConfig={appConfig}
  />
);
